namespace aq.settings {
    export class SettingsScheduleCategoriesCRUDCtrl {
        private svc: PlatformSettingsCrudModal;
        /* @ngInject */
        constructor(
            private $mdDialog: ng.material.IDialogService,
            private $q: ng.IQService,
            private Messages: any,
            private Restangular: restangular.IService,
            private Errors: any,
            private account: any,
            private object: any,
            private accountSettingsAccess: common.models.AppAccessObject
        ) {
            const restangularParams: ModalCrudRestangularParameters = {
                objectName: 'RuleCategory',
                restangularName: 'RuleCategories'
            };
            this.svc = new PlatformSettingsCrudModal(
                $mdDialog,
                $q,
                Restangular,
                Messages,
                Errors,
                restangularParams,
                object,
                this.account
            );
        }
    }
    angular.module('aq.settings').controller('SettingsScheduleCategoriesCRUDCtrl', SettingsScheduleCategoriesCRUDCtrl);
}
